import React, { forwardRef } from "react";
import { useFormContext } from "react-hook-form";
import { Button } from "@components/buttons";
import { ButtonProps } from "./types";

export default forwardRef<HTMLButtonElement, ButtonProps>(
	function FormCancelButton(props, ref) {
		const {
			formState: { dirtyFields },
		} = useFormContext();

		const isButtonDisabled = Object.keys(dirtyFields).length == 0;

		return (
			<Button
				{...props}
				ref={ref}
				disabled={isButtonDisabled || props.disabled}
			/>
		);
	}
);
